import { useEffect, useState } from 'react';
import { Accordion } from '@src/design-system/accordion';
import { SidebarGroup, SidebarMenu } from '@src/design-system/sidebar';

import { useGenerateNavLinks } from '@src/design-system/molecules/nav-main/hooks';
import { useIsActiveUrl } from './hooks';

import { NavLinkWithoutChildren } from './nav-link-without-children';
import { NavLinkWithChildren } from './nav-link-with-children';

export function NavMain() {
  const sidebarLinks = useGenerateNavLinks();
  const isActiveUrl = useIsActiveUrl();
  const [accordionValue, setAccordionValue] = useState<string | undefined>(
    undefined
  );

  const activeLink = sidebarLinks.find((l) => {
    const parentActive =
      'url' in l && l.url ? isActiveUrl(l.url) : false;
    const childActive = l.items?.some((subItem) => isActiveUrl(subItem.url));
    return parentActive || childActive;
  });

  useEffect(() => {
    setAccordionValue(undefined);
  }, [activeLink?.title]);

  const value =
    accordionValue !== undefined ? accordionValue : (activeLink?.title ?? '');

  return (
    <SidebarGroup>
      <SidebarMenu>
        <Accordion
          type='single'
          collapsible
          asChild
          value={value === '' ? undefined : value}
          onValueChange={setAccordionValue}
          className='group/collapsible'
        >
          <>
            {sidebarLinks.map((item) => {
              const isItemWithItems = 'items' in item && item.items;

              return isItemWithItems ? (
                <NavLinkWithChildren
                  key={item.title}
                  item={item}
                  isSectionExpanded={value ? value === item.title : false}
                />
              ) : (
                <NavLinkWithoutChildren
                  key={item.title}
                  item={item}
                />
              );
            })}
          </>
        </Accordion>
      </SidebarMenu>
    </SidebarGroup>
  );
}
